import { urlEscaped } from '@app/utils/urlEscaped'

import { createApiAction } from '@app/packages/api/utils'
import type { ApiTrainingPromocode, ApiTrainingRequest, TrainingFormatName } from '@app/packages/api/v2/types/entities'
import type { TrainingSignUpRequest } from '@app/packages/api/v2/types/params'
import { v2Path } from '@app/packages/api/v2/utils'

export const getTrainingRequest = () =>
  createApiAction('getTrainingRequest', dispatch => dispatch<{ data: ApiTrainingRequest | null }>({ method: 'GET', endpoint: '/api/v2/training_request' }))

export const postTrainingRequest = (request: TrainingSignUpRequest) =>
  createApiAction('postTrainingRequest', dispatch =>
    dispatch<{ data: ApiTrainingRequest }>({ method: 'POST', endpoint: '/api/v2/training_request', body: JSON.stringify(request) })
  )

export const putTrainingRequestById = (id: string, request: { format: TrainingFormatName }) =>
  createApiAction('putTrainingRequestById', dispatch =>
    dispatch<{ data: ApiTrainingRequest }>({ method: 'PUT', endpoint: urlEscaped`/api/v2/training_request/${id}`, body: JSON.stringify(request) })
  )

export const postTrainingRequestConfirmation = (token: string) =>
  createApiAction('postTrainingRequestConfirmation', dispatch =>
    dispatch<{ data: ApiTrainingRequest }>({ method: 'POST', endpoint: '/api/v2/training_request/confirmation', body: JSON.stringify({ token }) })
  )

export const getTrainingRequestPromocodesByToken = (token: string, format: TrainingFormatName, region_id?: string) =>
  createApiAction('getTrainingRequestPromocodesByToken', dispatch =>
    dispatch<{ data: ApiTrainingPromocode }>({
      method: 'GET',
      endpoint: v2Path(urlEscaped`/api/v2/training_request/promocodes/${token}`, { training_format: format, region_id }),
    })
  )
